import { BaseView } from "./base-view";
/**
 * Create a children pack for each object field
 * @class ObjectView
 * @extends BaseView
 */
export class ObjectView extends BaseView {
    constructor(model) {
        super();
        this.model = model;
    }
    $ready() {
        const obj = this.model;
        for (const key in obj) {
            this.createChild(key, obj[key]);
        }
        super.$ready();
    }
}
